import React, { useContext, useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { AuthRequestDto } from "../../generated/src";
import SwaggerContext from "../../SwaggerContext";
import { useNavigate } from "react-router-dom";

import CheckButton from "react-validation/build/button";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";

import { login } from "../../actions/auth";
import { clearMessage } from "../../actions/message";
import appLogo from "../../resources/app.jpg";

const required = (value) =>
  !value && <div className="alert alert-danger" role="alert">Este campo es obligatorio</div>;

const Login = () => {
  const { userApi } = useContext(SwaggerContext);

  const form = useRef();
  const checkBtn = useRef();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const { isLoggedIn, user } = useSelector((state) => state.auth);
  const { message } = useSelector((state) => state.message);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();


  // Limpiar mensajes de error al montar el componente
  useEffect(() => {
    dispatch(clearMessage());
  }, [dispatch]);

  // Autorrelleno desde navigate("/login", { state: { username, password } })
  useEffect(() => {
    const s = location.state || {};
    if (s.username) setUsername(s.username);
    if (s.password) setPassword(s.password);
  }, [location.state]);

  const onChangeUsername = (e) => {
    setUsername(e.target.value);
    if (message) dispatch(clearMessage());
  };
  
  const onChangePassword = (e) => {
    setPassword(e.target.value);
    if (message) dispatch(clearMessage());
  };

  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      const authRequest = new AuthRequestDto();
      authRequest.username = username;
      authRequest.password = password;

      dispatch(
        login(userApi, authRequest, (error) => {
          if (error) setLoading(false);
        })
      );
    } else {
      setLoading(false);
    }
  };

  if (isLoggedIn && user) {
    return <Navigate to="/inicio" />;
  }

  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      backgroundColor: "#f5f5f5",
      padding: "20px",
    }}>
      <div style={{ width: "100%", maxWidth: "420px" }}>
        <img
          src={appLogo}
          alt="CEAEmociones"
          style={{
            width: "96px",
            height: "96px",
            borderRadius: "50%",
            display: "block",
            margin: "0 auto 20px",
            objectFit: "contain",
          }}
        />
        <h1 style={{
          fontSize: "32px",
          fontWeight: "bold",
          textAlign: "center",
          marginBottom: "10px",
        }}>
          <span style={{ color: "#e74c3c" }}>C</span>
          <span style={{ color: "#e67e22" }}>E</span>
          <span style={{ color: "#f1c40f" }}>A</span>
          <span style={{ color: "#2ecc71" }}>E</span>
          <span style={{ color: "#3498db" }}>m</span>
          <span style={{ color: "#2980b9" }}>o</span>
          <span style={{ color: "#9b59b6" }}>c</span>
          <span style={{ color: "#e74c3c" }}>i</span>
          <span style={{ color: "#e67e22" }}>o</span>
          <span style={{ color: "#f1c40f" }}>n</span>
          <span style={{ color: "#2ecc71" }}>e</span>
          <span style={{ color: "#3498db" }}>s</span>
        </h1>
        <p style={{
          fontSize: "16px",
          color: "#666",
          textAlign: "center",
          marginBottom: "40px",
        }}>
          Inicia sesión para continuar
        </p>

        <Form onSubmit={handleLogin} ref={form}>
          <div className="form-group mb-3">
            <Input
              type="text"
              className="form-control form-control-lg"
              name="username"
              placeholder="Usuario"
              value={username}
              onChange={onChangeUsername}
              validations={[required]}
              style={{
                borderRadius: "8px",
                border: "1px solid #ddd",
                padding: "15px",
                fontSize: "16px",
              }}
            />
          </div>

          <div className="form-group mb-3">
            <Input
              type="password"
              className="form-control form-control-lg"
              name="password"
              placeholder="Contraseña"
              value={password}
              onChange={onChangePassword}
              validations={[required]}
              style={{
                borderRadius: "8px",
                border: "1px solid #ddd",
                padding: "15px",
                fontSize: "16px",
              }}
            />
          </div>

          <div className="form-group mt-3">
            <button
              className="btn w-100"
              disabled={loading}
              style={{
                backgroundColor: "#3498db",
                color: "#fff",
                borderRadius: "8px",
                padding: "15px",
                fontSize: "18px",
                fontWeight: "bold",
                border: "none",
              }}
            >
              {loading && <span className="spinner-border spinner-border-sm me-2"></span>}
              <span>Iniciar Sesión</span>
            </button>
          </div>

          {message && (
            <div className="form-group mt-4">
              <div className="alert alert-danger" role="alert">
                {message}
              </div>
            </div>
          )}
          <CheckButton style={{ display: "none" }} ref={checkBtn} />
        </Form>

        <div className="text-center" style={{ marginTop: "15px" }}>
          <button
            type="button"
            className="btn btn-link"
            onClick={() => navigate("/password/restore")}
            style={{ color: "#95a5a6", fontSize: "14px", textDecoration: "none" }}
          >
            ¿Olvidaste tu contraseña?
          </button>
        </div>
        <div className="text-center" style={{ marginTop: "15px" }}>
          <button
            type="button"
            className="btn btn-link"
            onClick={() => navigate("/register")}
            style={{ color: "#3498db", fontSize: "16px", textDecoration: "none" }}
          >
            ¿No tienes cuenta? Regístrate
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
